import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface AddRowButtonProps {
  label?: string;
  onAddClick?: () => void;
}

export const AddRowButton = ({ onAddClick, label }: AddRowButtonProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'DataGrid.addButton' });
  return (
    <Button
      sx={{ lineHeight: 'normal' }}
      color="primary"
      size="small"
      variant="text"
      startIcon={<Add />}
      onClick={onAddClick}
    >
      {label ?? t('label')}
    </Button>
  );
};
